import { createReducer, on } from '@ngrx/store';
import { AuditLog } from '@shared/models/audit-log.model';
import { Pagination } from '@shared/models/pagination.model';

import {
  supplierPartnerCouponClearSate,
  supplierPartnerCouponHistoryRequest,
  supplierPartnerCouponHistoryResponse,
  supplierPartnerCouponListRequest,
  supplierPartnerCouponListResponse,
  supplierPartnerCouponProductResponse,
  supplierPartnerCouponViewRequest,
  supplierPartnerCouponViewResponse
} from './supplier-partner-coupon.actions';
import {
  SupplierPartnerCouponContent,
  SupplierPartnerCouponCriteria,
  SupplierPartnerCouponPagination,
  SupplierPartnerCouponProduct
} from '../models/supplier-partner-coupon.model';

export const supplierPartnerCouponFeatureKey = 'supplierPartnerCoupon';

export interface SupplierPartnerCouponState {
  supplierPartnerCouponList: SupplierPartnerCouponPagination;
  criteriaObject: SupplierPartnerCouponCriteria;
  supplierPartnerCouponView: SupplierPartnerCouponContent;
  auditLogs: AuditLog[];
  product: {
    INCLUDE: Pagination<SupplierPartnerCouponProduct>;
    EXCLUDE: Pagination<SupplierPartnerCouponProduct>;
  };
}

export const initialState: SupplierPartnerCouponState = {
  supplierPartnerCouponList: null,
  criteriaObject: null,
  supplierPartnerCouponView: null,
  auditLogs: [],
  product: {
    INCLUDE: null,
    EXCLUDE: null
  }
};

export const supplierPartnerCouponReducer = createReducer(
  initialState,
  on(supplierPartnerCouponClearSate, () => {
    return initialState;
  }),
  on(supplierPartnerCouponListRequest, (state, { payload }) => {
    return {
      ...state,
      criteriaObject: payload
    };
  }),
  on(supplierPartnerCouponListResponse, (state, { response }) => {
    return {
      ...state,
      supplierPartnerCouponList: response
    };
  }),
  on(supplierPartnerCouponViewRequest, (state) => {
    return {
      ...state,
      supplierPartnerCouponView: null
    };
  }),
  on(supplierPartnerCouponViewResponse, (state, { response }) => {
    return {
      ...state,
      supplierPartnerCouponView: response
    };
  }),
  on(supplierPartnerCouponHistoryRequest, (state) => {
    return {
      ...state,
      auditLogs: []
    };
  }),
  on(supplierPartnerCouponHistoryResponse, (state, { response }) => {
    return {
      ...state,
      auditLogs: response
    };
  }),
  on(supplierPartnerCouponProductResponse, (state, { response, usage }) => {
    return {
      ...state,
      product: {
        ...state.product,
        [usage]: response
      }
    };
  })
);
